
import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Box,
  IconButton,
  Typography,
  useMediaQuery,
  Menu,
  MenuItem
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import logo1 from '../../assets/logo1.svg';
import logo2 from '../../assets/logo2.svg';
import infoicon from '../../assets/infoicon.svg';
import Japan from '../../assets/Japan.svg';     // English flag
import spanish from '../../assets/spanish.svg'; // Spanish flag
import CustomButton from '../CustomButton';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import websitelogo from "../../assets/websitelogo.png"; 
import websitelogoes from "../../assets/websitelogoes.png"; 
const RegisterHeader= () => {
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md')); 
  const [menuOpen, setMenuOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
//   const [language, setLanguage] = useState('English');
const language = i18n.language === 'es' ? 'Español' : 'English';
const navigate=useNavigate()
  const handleMenuToggle = () => {
    setMenuOpen(prev => !prev);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
const handleLogin=()=>{
    navigate("/")
}

  const handleSelect = (lang) => {
//   setLanguage(lang);
  i18n.changeLanguage(lang === 'English' ? 'en' : 'es');
  handleClose();
};

  const currentFlag = language === 'English' ? Japan : spanish;

  const LanguageSelector = (
    <>
      <Box
        onClick={handleClick}
        display="flex"
        alignItems="center"
        gap={0.4}
        sx={{
          backgroundColor: "#091E420F",
          height: "40px",
          borderRadius: "4.34px",
          padding: "0px 18px",
          fontSize: "1rem",
          cursor: 'pointer',
         
        }}
        >
        {/* <Box
          component="img"
          src={currentFlag}
          alt="Language Flag"
          sx={{ width: 22, height: 22, objectFit: 'contain', mr: 1 }}
        /> */}
        <Typography variant="body2" sx={{ fontSize: 14, color: '#172B4D', fontWeight: 400,   fontFamily: 'Poppins, sans-serif', }}>
          {language}
        </Typography>
        <ExpandMoreIcon fontSize="small" sx={{ ml: 0.5 }} />
      </Box>

      <Menu
  anchorEl={anchorEl}
  open={open}
  onClose={handleClose}
  anchorOrigin={{
    vertical: 'bottom',
    horizontal: 'left',
  }}
  transformOrigin={{
    vertical: 'top',
    horizontal: 'left',
  }}
  PaperProps={{
    sx: {
      mt: 1,
      borderRadius: '10px',
      px: 0,
      boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
      border: "1px solid #ccc",
width: isMobile ? '100%' : isTablet ? '20%' : '8%',
    }
  }}
>
        <MenuItem onClick={() => handleSelect('Spanish')} sx={{ gap: 1 }}>
          {/* <Box component="img" src={spanish} alt="Spanish" sx={{ width: 20, height: 20 }} /> */}
                <Typography variant="body2" sx={{ fontSize: 14, color: '#172B4D', fontWeight: 400,  fontFamily: 'Poppins, sans-serif', }}>

           {t("spanish")}</Typography>
        </MenuItem>
        <MenuItem onClick={() => handleSelect('English')} sx={{ gap: 1 }}>
          {/* <Box component="img" src={Japan} alt="English" sx={{ width: 20, height: 20 }} /> */}
               <Typography variant="body2" sx={{ fontSize: 14, color: '#172B4D', fontWeight: 400,   fontFamily: 'Poppins, sans-serif', }}>

                {t("english")}</Typography>
        </MenuItem>
      </Menu>
    </>
  );
  const Logopath = language === 'English' ? websitelogoes: websitelogo;
  return (
    <AppBar position="fixed" color="white" elevation={0} sx={{backgroundColor:"white", py: 0.6, px: 2, }}>
      <Toolbar sx={{ justifyContent: 'space-between' }}>

   
        <Box display="flex" alignItems="center" gap={1.5}>
        <img src={Logopath}  style={{width:180,height:70,objectFit:"contain"}}/>
        </Box>

        {/* Right Section */}
        {isMobile ? (
       <IconButton onClick={handleMenuToggle}>
                  {menuOpen ? <CloseIcon /> : <MenuIcon />}
                </IconButton>
              ) : (
          <Box display="flex" alignItems="center" gap={1.4}>
       
                       {/* <Box display="flex" alignItems="center" gap={1.4}>
       
          
     <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <IconButton size="small">
                <Box
                  component="img"
                  src={infoicon}
                  alt="Info"
                  sx={{ width: 22, height: 22, objectFit: 'contain' }}
                />
              </IconButton>
              <Box
                sx={{
                  position: 'absolute',
                  top: '100%',
                  right: 0,
                  mt: 0.5,
                  backgroundColor: "#44546F",
                  px: 1.3,
                  py: 0.4,
                  borderRadius: "4px",
                  whiteSpace: 'nowrap'
                }}
              >
                <Typography sx={{ fontSize: 12, color: '#FFFFFF', fontWeight: 400,   fontFamily: 'Poppins, sans-serif', }}>
                    {t('tooltip.short')}
                </Typography>
              </Box>
            </Box>
       
          </Box> */}
          

            {LanguageSelector}

            <CustomButton 

            // label="Create Account"
       label={t('loginButton')} 
             onClick={handleLogin} buttonVariant="primary" size="medium" />
          </Box>
        )}
      </Toolbar>

      {/* Mobile Dropdown */}
      {isMobile && menuOpen && (
        <Box
          sx={{
            px: 2,
            pb: 2,
            backgroundColor: 'white',
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
       
          }}
        >
          
                      {/* <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center',mb:3 }}>
                        <IconButton size="small">
                          <Box
                            component="img"
                            src={infoicon}
                            alt="Info"
                            sx={{ width: 22, height: 22, objectFit: 'contain' }}
                          />
                        </IconButton>
                        <Box
                          sx={{
                            position: 'absolute',
                            top: '100%',
                            mt: 0,
                            backgroundColor: "#44546F",
                            px: 1.3,
                            py: 0.4,
                            borderRadius: "4px",
                            whiteSpace: 'nowrap'
                          }}
                        >
                          <Typography sx={{ fontSize: 12, color: '#FFFFFF', fontWeight: 400, }}>
                             {t('tooltip.short')}
                          </Typography>
                        </Box>
                      </Box> */}
       

          {/* Language Dropdown in Mobile View */}
          {LanguageSelector}

          <CustomButton 
            label={t('loginButton')} 
           onClick={handleLogin} buttonVariant="primary" size="medium" />
        </Box>
      )}
    </AppBar>
  );
};

export default RegisterHeader;